export const getLatestBookingStatus = (bookingHistory) => {

    const bookingStatusPriority = ['arrived', 'reviewed', 'approved', 'created'];

    const latestStatus = bookingHistory
        .slice()
        .sort((a, b) => Number(b.createdAt) - Number(a.createdAt))
        .find(item => bookingStatusPriority.includes(item.status));

    const isBookingStarted = bookingHistory.some(item =>
        item.status === 'started' || item.status === 'cancelledByPartner'
    );

    return isBookingStarted ? null : latestStatus;
};
